export default __webpack_public_path__ + "images/7fcd7479ba11f45d610c29878eaa590f.svg";